import React from "react";

const NotFound = () => {
  return (
    <div>
      <h1>404 =(</h1>
      <p>Esta página no existe.</p>
    </div>
  );
};

export default NotFound;
